import { Capacitor } from '@capacitor/core';
import { createVapiProvider } from './vapiProvider';
import { createRetellProvider } from './retellProvider';
import { subscribeRetellTranscript } from './retellTranscriptChannel';
import { subscribeRetellMonitorTranscript } from './retellMonitorTranscript';
import { supabase } from '../supabase';

const cache = {};

// Live transcript source. Retell's monitor stream (a domain-allowlisted public
// key) grows each utterance word by word; the retell-webhook relay only carries
// finished turns. Prefer the stream, keep the relay as the fallback and as the
// only source when no public key is configured.
const subscribeTranscript = (callId, onTurns) => {
  const publicKey = import.meta.env.VITE_RETELL_PUBLIC_KEY;
  const relay = (id, cb) => subscribeRetellTranscript(supabase, id, cb);
  return publicKey
    ? subscribeRetellMonitorTranscript(callId, onTurns, { publicKey, fallback: relay })
    : relay(callId, onTurns);
};

/** Returns a memoized provider instance. name: 'vapi' | 'retell'. */
export const getProvider = (name) => {
  const key = name === 'retell' ? 'retell' : 'vapi';
  if (!cache[key]) {
    cache[key] = key === 'retell'
      ? createRetellProvider({
          subscribeTranscript,
          // Web Audio on the remote WebRTC track is unverified in iOS/Android WebViews
          // (audio re-routing risk). Enable for native only after a device test passes.
          detectTalkFromAudio: !Capacitor.isNativePlatform(),
        })
      : createVapiProvider();
  }
  return cache[key];
};
